module.exports = __webpack_public_path__ + "static/vorbeugung-4e28335ad46bbf5debeea64a09f3a3cb.jpg";